import { useMutation, useQueryClient, MutationOptions } from "react-query";
import { patch, API_URL, APIResponse, APIError } from "../api";

export function useUpdateCartItem(
  options?: MutationOptions<
    APIResponse<any>,
    APIError,
    { cartItemId: string; quantity: number }
  >
) {
  const queryClient = useQueryClient();

  const { mutate, isLoading, isError, error, data } = useMutation(
    ({ cartItemId, quantity }) => {
      return patch(
        `${API_URL}/commerce/cart/items/${cartItemId}`,
        { quantity },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
    },
    {
      ...options,
      onSuccess: (...args) => {
        queryClient.refetchQueries("cart");
        options?.onSuccess?.(...args);
      },
    }
  );

  return {
    updateCartItem: mutate,
    updatingCartItem: isLoading,
    isUpdateCartError: isError,
    updateCartError: error,
    updateCartResponse: data,
  };
}
